<a
  tabindex="0"
  class="array-input"
  (click)="!disabled && click($event, column)"
  (keydown.space)="!disabled && click($event, column)"
  [matTooltip]="displayValue"
  [matTooltipClass]="'tooltip'"
>
  <div class="array-text-box" [ngClass]="{ disabled: disabled }">{{ displayValue }}</div>
</a>
